import { AccountItemBlock } from "./AccountItem";
import PimsExportFormatSetting from "./PimsExportFormatSetting";

export default function PimsExportingSettings() {
  return (
    <div className="flex-1 flex flex-col gap-md">
      <div className="flex flex-col space-y-4 divide-y divide-secondary">
        <AccountItemBlock
          title="Export Format:"
          desc="Choose the format used when exporting notes to your PIMS. The best option depends on how your PIMS handles pasted text."
        >
          <PimsExportFormatSetting />
        </AccountItemBlock>
      </div>
    </div>
  );
}
